import ForgotForm from "components/Forms/custom/ForgotForm";
import InfoLayout from "components/InfoLayout/InfoLayout";

const PasswordForgot = () => {
  return <InfoLayout component={<ForgotForm />} />;
};

export default PasswordForgot;
